export default __webpack_public_path__ + "static/media/006-beer.6cf9a55e.svg";